/**
 * Unwrap Promise<T> into just T
 * @example Awaited<Promise<T>> // T
 */
export type Awaited<T> = T extends PromiseLike<infer U> ? Awaited<U> : T;
